import {
  List,
  Datagrid,
  FunctionField,
  TextInput,
  BooleanInput,
  RaRecord,
} from 'react-admin';
import {
  NameInlineCell,
  SourceCell,
  CooperationCell,
  VehiclesCell,
  StatusCell,
} from './cells';
import { Stack } from '@mui/material';
import { SyncStatus } from '../SyncStatus';
import { compactDatagridSx } from '../../shared/listCells';
import { menuLabel } from '../menuConfig';

// „po nazwie”, nie „nazwa / miasto” — TMS nie podaje miast przewoźników,
// więc szukanie po mieście nic nie znajdowało (07.10.2026). Klucz `q` bez zmian.
const filters = [
  <TextInput source="q" label="Szukaj po nazwie" alwaysOn />,
  <BooleanInput source="zeZleceniami" label="Tylko ze zleceniami" alwaysOn />,
];

/**
 * Kartoteka przewoźników — lista.
 *
 * Powstaje z pola `carrier` przy zleceniach; ich interfejs nie ma osobnego
 * zasobu przewoźników. NIP/VAT, współpracę i kontakty uzupełnia Trade na
 * karcie przewoźnika (I.07).
 */
export const CarrierList = () => (
  <List
    filters={filters}
    sort={{ field: 'name', order: 'ASC' }}
    perPage={25}
    title={menuLabel('carriers')}
  >
    <Stack spacing={1}>
      {/* Kartoteka pochodzi z TMS (W12): kiedy ostatnio pobrana i z jakim wynikiem. */}
      <SyncStatus />
    {/* Wiersz w jednej linii: nazwa skracana z podpowiedzią, znaczniki obok
        siebie (28.09.2026 — lista miała wiersze po trzy linie i nagłówki
        łamane w pół). */}
    <Datagrid
      rowClick="show"
      bulkActionButtons={false}
      sx={{ ...compactDatagridSx, '& .MuiStack-root': { flexWrap: 'nowrap' } }}
    >
      <FunctionField
        label="Przewoźnik"
        render={(r: RaRecord) => <NameInlineCell record={r} />}
      />
      {/* Bez kolumny „Adres” (07.10.2026): TMS nie podaje adresów
          przewoźników, więc w każdym wierszu stało to samo „TMS nie podaje
          adresu”. Karta pokazuje adres, gdy kiedyś się pojawi. */}
      <FunctionField label="Rodzaj" render={(r: RaRecord) => <SourceCell record={r} />} />
      {/* Liczba zleceń, więc „Zlecenia” — „Współpraca” na karcie znaczy
          tak / nie / nieustalona i nagłówek mylił (e2e, 28.09.2026). */}
      <FunctionField
        label="Zlecenia"
        render={(r: RaRecord) => <CooperationCell record={r} />}
      />
      {/* Nagłówki zwykłymi słowami, bez „Status / NIP” (01.10.2026). */}
      <FunctionField label="Pojazdy w zleceniach" render={(r: RaRecord) => <VehiclesCell record={r} />} />
      <FunctionField label="Współpraca i NIP" render={(r: RaRecord) => <StatusCell record={r} />} />
    </Datagrid>
    </Stack>
  </List>
);
